<template>
  <ManageForm :on-cancel="onCancel" :on-confirm="onConfirm" />
</template>

<script setup>
import ManageForm from './ManageForm.vue'
import { publicApi } from '@/app-bootstrapping/SetUpApollo'
import { CreateTrustedContactMutation } from '@/components/Contacts/CompanyFreelancer/mutations/CreateTrustedContactMutation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import { TrustedContactOriginChannel, TrustedContactOrigin } from '@/gql/graphql'

const props = defineProps({
  accountId: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['cancel', 'close', 'added'])

function onCancel() {
  emit('cancel')
}

function onConfirm(data, action) {
  return publicApi
    .mutate({
      mutation: CreateTrustedContactMutation,
      variables: {
        input: {
          company: props.accountId,
          ...data.name.value,
          email: data.email.value,
          country: data.country.value?.value ?? '',
          state: data.state.value?.value ?? '',
          links: data.links.value.map((link) => link.url),
          attachments: data.attachments.value.map((attachment) => attachment.id),
          skills: data.skills.value,
          externalIdentifier: data.externalIdentifier.value,
          message: data.message.value,
          notifyWorker: true,
          customFieldValues: data.customFieldValues.value,
          originChannel: TrustedContactOriginChannel.DirectInvite,
          origin: TrustedContactOrigin.Invited,
        },
      },
    })
    .then((result) => {
      if (action === 'inviteOnly') {
        emit('added')

        if (result.data.createTrustedContact.worker.id) {
          emit('close')
        }
      } else {
        emit('added')

        window.location.assign(
          laravelNamedRoute(namedRoutes.frontend.user.profile.hiredirect, {
            freelancer: result.data.createTrustedContact.worker.id,
          }),
        )
      }
    })
    .catch((error) => {
      throw error
    })
}
</script>
